import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Mobx from "mobx";
import AppBody from "./views/appBody";

Mobx.useStrict(true);
ReactDOM.render(<AppBody />, document.getElementById("app"));


// WEBPACK FOOTER //
// ./src/index.tsx